module.exports = __webpack_public_path__ + "static/media/chili.652836e5.png";